/**
 * @generated SignedSource<<4ca6b71edee50e32a074002bc55ff3d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraGoalStatus = "ARCHIVED" | "AT_RISK" | "CANCELLED" | "COMPLETED" | "DONE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type GoalGroupHeader$data = {
  readonly displayName: string;
  readonly goal: {
    readonly id?: string;
    readonly key?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly score: number | null | undefined;
    readonly status: JiraGoalStatus | null | undefined;
  };
  readonly " $fragmentType": "GoalGroupHeader";
};
export type GoalGroupHeader$key = {
  readonly " $data"?: GoalGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoalGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "GoalGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalgroupheadersmartlinkrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "status"
        },
        {
          "kind": "ScalarField",
          "name": "score"
        }
      ]
    }
  ],
  "type": "JiraJqlGoalsFieldValue"
};

(node as any).hash = "79831ca506d15357a3f5270b01ab437f";

export default node;
